import { Link, Typography } from '@mui/material';
import { Link as RouterLink, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StandaloneFrame } from '@/shell/StandaloneFrame';

export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  if (import.meta.env.DEV) console.error(error);
  return (
    <StandaloneFrame>
      <Typography variant="h1" gutterBottom>
        {t('routeError.title')}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t('routeError.body')}
      </Typography>
      <Link component={RouterLink} to="/">
        {t('common.goHome')}
      </Link>
    </StandaloneFrame>
  );
}
